import React from 'react';
import Icon from '../../../components/AppIcon';

const ReadinessScore = ({ score, breakdown }) => {
  const getScoreColor = (value) => {
    if (value >= 70) return 'text-success';
    if (value >= 40) return 'text-warning';
    return 'text-error';
  };

  const getScoreGradient = (value) => {
    if (value >= 70) return 'from-success to-success/60';
    if (value >= 40) return 'from-warning to-warning/60';
    return 'from-error to-error/60';
  };

  const getScoreLabel = (value) => {
    if (value >= 80) return 'Sangat Siap';
    if (value >= 60) return 'Siap dengan Catatan';
    if (value >= 40) return 'Perlu Perbaikan';
    return 'Tidak Siap';
  };

  return (
    <div className="card bg-gradient-to-br from-card to-primary/5 shadow-xl border-2">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent">Skor Kesiapan Scale-Up</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Penilaian komprehensif kesiapan ekspansi bisnis
          </p>
        </div>
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg animate-pulse">
          <Icon name="TrendingUp" size={28} className="text-primary-foreground" />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row items-center gap-8 mb-8">
        <div className="relative w-56 h-56 flex-shrink-0">
          <svg className="w-full h-full transform -rotate-90">
            <defs>
              <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor={score >= 70 ? 'var(--color-success)' : score >= 40 ? 'var(--color-warning)' : 'var(--color-error)'} />
                <stop offset="100%" stopColor={score >= 70 ? 'var(--color-success)' : score >= 40 ? 'var(--color-warning)' : 'var(--color-error)'} stopOpacity="0.6" />
              </linearGradient>
            </defs>
            <circle
              cx="112"
              cy="112"
              r="90"
              stroke="var(--color-muted)"
              strokeWidth="20"
              fill="none"
            />
            <circle
              cx="112"
              cy="112"
              r="90"
              stroke="url(#scoreGradient)"
              strokeWidth="20"
              fill="none"
              strokeDasharray={`${(score / 100) * 565.2} 565.2`}
              strokeLinecap="round"
              className="transition-all duration-1000 drop-shadow-lg"
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className={`text-6xl font-bold data-text ${getScoreColor(score)} drop-shadow-lg`}>
              {score}
            </span>
            <span className="text-sm text-muted-foreground mt-1 font-medium">dari 100</span>
          </div>
        </div>

        <div className="flex-1 w-full">
          <div className={`text-3xl font-bold mb-4 ${getScoreColor(score)} drop-shadow-sm`}>
            {getScoreLabel(score)}
          </div>
          <p className="text-sm md:text-base text-muted-foreground mb-6 leading-relaxed">
            Berdasarkan analisis mendalam terhadap 6 dimensi kritis: pasokan, operasional, peralatan, keuangan, pasar, dan tata kelola.
          </p>

          <div className="space-y-4">
            {breakdown?.map((item) => (
              <div key={item?.dimension} className="space-y-2 p-3 rounded-xl bg-gradient-to-r from-muted/50 to-transparent hover:from-muted transition-all duration-300">
                <div className="flex items-center justify-between text-sm">
                  <span className="font-semibold">{item?.dimension}</span>
                  <span className={`font-bold data-text text-lg ${getScoreColor(item?.score)}`}>
                    {item?.score}/100
                  </span>
                </div>
                <div className="w-full h-3 bg-muted rounded-full overflow-hidden shadow-inner">
                  <div
                    className={`h-full transition-all duration-700 bg-gradient-to-r ${getScoreGradient(item?.score)} shadow-lg`}
                    style={{ width: `${item?.score}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadinessScore;